import { DateTime } from 'luxon'

export function formatDate (dateString: string) : string {
  const date = new Date(dateString)
  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return date.toLocaleString('en-NZ', options)
}

export function dateTimeNzFormat (date: string | null | undefined): string {
  if (date === null || date === undefined) {
    return '-'
  }

  return DateTime.fromISO(date).toFormat('dd/LL/yyyy HH:mm')
}

// Format a Date object to ISO string and extract the date part (YYYY-MM-DD)
export function formatIsoDate (date: Date | undefined | null): string {
  if (date === undefined || date === null) {
    return ''
  }

  return date.toISOString().slice(0, 10)
}

// Format date string to return 'dd/LL/yyyy' format
export function dateOnlyNzFormat (date: string | null): string {
  if (date === '') {
    return ''
  }
  if (date === null) {
    return '-'
  }

  return DateTime.fromISO(date).toFormat('dd/LL/yyyy')
}

// Format date string to return day of the week eg. Monday, Tuesday...
export function formatDayOfWeek (dateString: string | null): string {
  if (dateString === null) {
    return '-'
  }

  const date = DateTime.fromISO(dateString)

  if (!isNaN(date.day)) {
    return date.toFormat('cccc') // e.g. Monday, Tuesday...
  } else {
    return 'Invalid Date String'
  }
}

// Format date string to return day of the week eg. Mon, Tue...
export function formatDayOfWeekShortName (dateString: string | null): string {
  if (dateString === null) {
    return '-'
  }

  const date = new Date(dateString)

  if (!isNaN(date.getTime())) {
    return date.toLocaleDateString(undefined, { weekday: 'short' })
  } else {
    return 'Invalid Date String'
  }
}

// Format time object { hours: 0, minutes: 0 } to return '00:00:00' format
export function formatTimeObjectTo24Hrs (timeObject: { hours: number; minutes: number }) {
  const time = new Date()
  time.setHours(timeObject.hours, timeObject.minutes, 0, 0)

  const nzOptions = { timeZone: 'Pacific/Auckland', hour12: false }
  return time.toLocaleTimeString('en-NZ', nzOptions)
}

// Format activation period as number
export function getActivationPeriodAsNumber (activationPeriod: string | number): number {
  const activationPeriodString = activationPeriod.toString()
  return parseInt(activationPeriodString.replace(/P|D/g, ''))
}

// Convert date string to JSDate object
export function convertDateStringToDateTime (dateString: string | undefined): Date | undefined {
  if (dateString === undefined) {
    return undefined
  }

  return DateTime.fromFormat(dateString, 'dd/MM/yyyy HH:mm', { zone: 'Pacific/Auckland' }).toJSDate()
}

// Convert JSDate object to date string eg 'dd/MM/yyyy'
export function convertDateTimeToDateTimeString (dateTime: Date | undefined): string | undefined {
  if (dateTime === undefined) {
    return undefined
  }

  return DateTime.fromJSDate(dateTime).toFormat('dd/MM/yyyy HH:mm')
}

export function getTimestampSuffixForFilename () {
  const nowInNZ = DateTime.now().setZone('Pacific/Auckland')

  // Format the date and time in the desired format
  return nowInNZ.toFormat('yyyy-LL-dd__HH-mm-ss')
}

export function formatAndTimestampFileName (fileName: string): string {
  let cleanFileName = fileName.replace(/\s/g, '_').toLowerCase()
  cleanFileName = cleanFileName.replace(/\//g, '-')
  return `${cleanFileName}__${getTimestampSuffixForFilename()}`
}

export function getTimeOnly (dateString: Date | null | undefined): string {
  if (dateString === null || dateString === undefined) {
    return ''
  }

  // Return in this format: 'HH:mm:ss'
  return DateTime.fromJSDate(dateString).toFormat('HH:mm:ss')
}

export function dateOnlyApiFilterFormat (date: Date | null): string {
  if (date) {
    return DateTime.fromJSDate(date).toFormat('yyyy-LL-dd')
  }
  return ''
}
